<script>
export default {
  props: {
    field: String,
  },
  computed: {
    value () { return this.$store.state.rules.parsedRule[this.field] },
  },
  render () {
   return this.$scopedSlots.default({
    'value': this.value,
    'commit': e => this.commit(e),
   })
  },
  methods: {
    commit (e) {
      const model = { ...this.$store.state.rules.parsedRule }
      model[this.field] = e
      this.$store.commit('rules/setParsedRule', model)
    }
  }
}
</script>